import React, { createContext, useState } from 'react';
import {api} from "../services/api";

export const PreviewContext = createContext(null);

